var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import { createXComponent } from '@deephaven/components';
import { BasePanel } from '@deephaven/dashboard';
import { listenForSessionClosed, listenForSessionOpened } from "../ConsoleEvents.js";
import { InputFilterEvent } from "../events/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Extends the base panel component to handle Session events and input filter events.
 */
class CorePanel extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "stopListenForSessionClosed", void 0);
    _defineProperty(this, "stopListenForSessionOpened", void 0);
    this.handleClearAllFilters = this.handleClearAllFilters.bind(this);
    this.handleSessionClosed = this.handleSessionClosed.bind(this);
    this.handleSessionOpened = this.handleSessionOpened.bind(this);
  }
  componentDidMount() {
    var glEventHub = this.props.glEventHub;
    this.stopListenForSessionClosed = listenForSessionClosed(glEventHub, this.handleSessionClosed);
    this.stopListenForSessionOpened = listenForSessionOpened(glEventHub, this.handleSessionOpened);
    glEventHub.on(InputFilterEvent.CLEAR_ALL_FILTERS, this.handleClearAllFilters);
  }
  componentWillUnmount() {
    var _this$stopListenForSe, _this$stopListenForSe2;
    var glEventHub = this.props.glEventHub;
    (_this$stopListenForSe = this.stopListenForSessionClosed) === null || _this$stopListenForSe === void 0 || _this$stopListenForSe.call(this);
    (_this$stopListenForSe2 = this.stopListenForSessionOpened) === null || _this$stopListenForSe2 === void 0 || _this$stopListenForSe2.call(this);
    glEventHub.off(InputFilterEvent.CLEAR_ALL_FILTERS, this.handleClearAllFilters);
  }
  handleClearAllFilters() {
    var onClearAllFilters = this.props.onClearAllFilters;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onClearAllFilters === null || onClearAllFilters === void 0 || onClearAllFilters(...args);
  }
  handleSessionClosed(session) {
    var onSessionClose = this.props.onSessionClose;
    onSessionClose === null || onSessionClose === void 0 || onSessionClose(session);
  }
  handleSessionOpened(session) {
    var onSessionOpen = this.props.onSessionOpen;
    onSessionOpen === null || onSessionOpen === void 0 || onSessionOpen(session);
  }
  render() {
    var _this$props = this.props,
      children = _this$props.children,
      otherProps = _objectWithoutProperties(_this$props, _excluded);

    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/_jsx(BasePanel, _objectSpread(_objectSpread({}, otherProps), {}, {
      children: children
    }));
  }
}
var XCorePanel = createXComponent(CorePanel);
export default XCorePanel;
//# sourceMappingURL=CorePanel.js.map